import React from 'react';
import { FormattedMessage } from 'react-intl';

type Errors = {
  message: string | undefined;
};

const ErrorLabelView = ({ message }: Errors) => {
  if (!message || message.length === 0) {
    return null;
  }

  return (
    <span className="invalid">
      <FormattedMessage id={message} />
    </span>
  );
};

export default ErrorLabelView;
